/** Delade typer för fotoskanningen (säkra att importera i webbläsaren). */
import type { ScanAiCall } from "./video-scan";

/** En pryl som AI:n hittat, med vilka av de uppladdade bilderna som visar den. */
export type PhotoGroup = {
  name: string;
  descriptor?: string;
  note: string;
  category?: string;
  quantity?: number;
  valueLow: number;
  valueHigh: number;
  confidence: "low" | "medium" | "high";
  /** Index i bildlistan (0-baserat) för de bilder som visar just den här prylen. */
  imageIndexes: number[];
  /** Hur högt värdet realistiskt kan gå – styr om djupanalysen behövs. */
  ceiling?: import("./value-triage").ValueCeiling;
  /** Kort motivering på svenska till triagenivån. */
  triageReason?: string;
};

export type PhotoScanDebug = {
  calls: ScanAiCall[];
  batches: { index: number; imageCount: number; itemCount: number; durationMs: number }[];
  candidateCount: number;
  finalCount: number;
  coverage: PhotoImageStatus[];
  totals: {
    inputTokens: number;
    outputTokens: number;
    credits: number;
    sek: number;
    durationMs: number;
  };
};

/** Slutstatus för varje uppladdad bild – ingen bild får försvinna tyst. */
export type PhotoImageStatus = {
  imageIndex: number;
  status: "pending" | "processing" | "matched" | "unidentified" | "unreadable" | "failed";
  itemNames: string[];
};

export type PhotoScanResult = {
  groups: PhotoGroup[];
  coverage: PhotoImageStatus[];
  debug?: PhotoScanDebug;
};

/** Max antal bilder per omgång. */
export const PHOTO_SCAN_MAX_IMAGES = 30;
/** Max storlek per bild efter komprimering i webbläsaren. */
export const PHOTO_SCAN_MAX_IMAGE_BYTES = 6 * 1024 * 1024;

/** Hur många fotoskanningar man får göra per dygn i respektive plan. */
export const PHOTO_SCAN_PER_DAY: Record<"free" | "plus" | "pro" | "expert", number> = {
  free: 0,
  plus: 3,
  pro: 15,
  expert: 25,
};
